import { render, staticRenderFns } from "./GestionPax.vue?vue&type=template&id=2863f466&"
import script from "./GestionPax.vue?vue&type=script&lang=js&"
export * from "./GestionPax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports